<template>
  <div>
    <md-card id="reports" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">visibility</i>
        </div>
        <h4 class="title">
          <span style="color: #3cb3a3; font-weight: 400;">Si</span><span
            style="color:black; font-size: .9em">VIEW</span>
        </h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-15">
            <md-field class="md-sm"> <label>Search</label><md-input v-model="currentSearchTxt"
                @keyup.enter="handleSearch" /> </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Date</label>
              <md-select v-model="currentFilterDate" name="currentFilterDate">
                <md-option v-for="(type, index) in filterDateOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15" v-if="organizations.length > 1">
            <md-field>
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization" @md-selected="organizationChanged">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Shop ID</label>
              <md-select v-model="currentShopId" name="currentFilterDate"
                :disabled="!(currentOrganization ? filterShopIdOptions.filter(i => i.orgId === currentOrganization) : []).length || !currentOrganization">
                <md-option
                  v-for="(type, index) in (currentOrganization ? filterShopIdOptions.filter(i => i.orgId === currentOrganization) : [])"
                  :key="index" :value="type.shopId">
                  {{ type.shopId }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-switch v-model="consultationsOnly">Consultations only</md-switch>
          </div>

          <div class="md-layout-item" style="align-items: end;" :class="[
            { 'md-size-20': organizations.length > 1 },
            { 'md-size-35': organizations.length <= 1 }
          ]">
            <div class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleSearch" :disabled="!currentShopId">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter patients</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-primary" @click="handleRefresh">
                <md-icon>refresh</md-icon>
                <md-tooltip md-direction="bottom">Refresh data</md-tooltip>
              </md-button>
              <md-button class="md-icon-button md-primary" @click="handleForceRefresh">
                <md-icon>cloud_download</md-icon>
                <md-tooltip md-direction="bottom">Refresh data based on Siview data</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <md-table id="reports-table" v-if="!isLoading" v-model="tableData"
          class="table-shopping table-striped table-hover">
          <md-table-row>
            <md-table-empty-state
              :md-description="filterShopIdOptions.length ? `No patients found for this time frame or search criteria` : 'We could not find any SiVIEW Shop ID configured for your organization. Please contact your administrator'"
              md-label="No patients found" />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }"
            :style="!item.last_consult ? 'pointer-events: none' : 'cursor:pointer'" @click="openConsultation(item)">
            <md-table-cell style="height: 55px;" />
            <md-table-cell md-label="Date" style="font-size: 0.88em; font-weight: 500">
              <span>{{ item.id.toString().padStart(7, '0') }}</span> <br />
              <small style="font-size: 0.87em; color: darkgreen">
                {{ formattedDate(item.updated_at) }}
              </small>
            </md-table-cell>

            <md-table-cell md-label="Patient" style="font-size: 1.13em">{{ item.firstname }} {{ item.lastname
            }}</md-table-cell>
            <md-table-cell md-label="EMR-ID" style="font-size: 0.95em; color: blue" class="emr-id-cell">{{
              item.web_emr_id || '-' }}</md-table-cell>
            <md-table-cell md-label="Date of birth">{{ item.birthdate ? formattedDate(item.birthdate) : '-'
            }}</md-table-cell>
            <md-table-cell md-label="Client/Pkg"><small>{{ item.client_number ? item.client_number.slice(0,
              11).toUpperCase() : '-' }}</small>
            </md-table-cell>
            <md-table-cell md-label="File/Screen"><small>{{ item.file_number ? item.file_number.slice(0,
              11).toUpperCase() : '-' }}</small>
            </md-table-cell>

            <md-table-cell md-label="Last Consult">{{ item.last_consult ? formattedDate(item.last_consult) : '-'
            }}</md-table-cell>

            <md-table-cell md-label="Actions" v-if="API_SERVICE.indexOf('-qa') >= 0">
              <md-button :disabled="creatingFakeExam"
                style="position: absolute;z-index: 1000;pointer-events: all;margin-top: -14px;" class="md-primary"
                @click.stop="createFakeExam(item)">
                <md-icon
                  style="margin-left: 0px !important; margin-right: 30px !important; padding-bottom: 6px; padding-right: 14px;">
                  add
                </md-icon>
                <md-tooltip md-direction="bottom">Create fake exam for testing</md-tooltip>
              </md-button>
            </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex;align-items: center;">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px;">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content:center; align-items:start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startPatient }}</u></b>
                to
                <b><u>{{ endPatient }}</u></b>. Total of
                <b><u>{{ totalPatients }}</u></b>
                patients.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <!-- MODAL CONSULTS -->
    <modal v-if="showConsults"
      style="overflow: auto;padding-left: 15vw;padding-right: 15vh;position: absolute;top: 0;z-index: 10;left: 0;height: 80vh;"
      m-container="modal-container-consults">
      <template slot="body">
        <div class="md-layout">
          <!--   @click="rptPreview = false" -->
          <div class="md-layout-item">
            <siviewconsults id="svConsults" :cDATA="modalData" @onCloseConsults="handleConsultClose" />
          </div>
        </div>
      </template>
    </modal>

    <loader :is-visible="isLoading || isConsultationLoading" />
  </div>
</template>

<script>
import Swal from "sweetalert2"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"
import { Modal } from "@/components"
import SiVIEWConsults from "@/components/GlobeChek/SiVIEW/siview-consults"

export default {
  components: {
    loader,
    Modal,
    siviewconsults: SiVIEWConsults,
  },
  data() {
    return {
      API_SERVICE: process.env.VUE_APP_URL,
      allPatients: [],
      filteredPatients: [],
      tableData: [],
      currentSort: "name",
      currentSortOrder: "asc",
      orderAsc: false,
      offset: 0,
      limit: 50,
      totalPatients: 0,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      isLoading: false,
      isConsultationLoading: false,
      filterDateOptions: [
        {
          label: 'All',
          value: 'all',
        },
        {
          label: 'Past day',
          value: 'pastDay',
        },
        {
          label: 'Past week',
          value: 'pastWeek',
        },
        {
          label: 'Past month',
          value: 'pastMonth',
        },
        {
          label: 'Past 3 months',
          value: 'past3Months',
        },
        {
          label: 'Past 6 months',
          value: 'past6Months',
        },
        {
          label: 'Past year',
          value: 'pastYear',
        }
      ],
      filterShopIdOptions: [],
      consultationsOnly: false,
      currentSearchTxt: "",
      currentFilterDate: 'all',
      currentFilterStatus: 'all',
      currentShopId: null,
      showConsults: false,
      creatingFakeExam: false,
      modalData: {
        patient: {},
        mConsults: [],
        defaultCylinder: 'PLUS_CYLINDER'
      },
      currentOrganization: localStorage.getItem('currentOrgSelectedForFilters') != 'all' ? localStorage.getItem('currentOrgSelectedForFilters') : JSON.parse(sessionStorage.getItem('organizations'))[0].orgId,
      organizations: [
        ...JSON.parse(sessionStorage.getItem('organizations')).map(i => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        }),
      ],
    }
  },
  computed: {
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.filteredPatients.length
    },
    startPatient() {
      return this.offset + 1;
    },
    endPatient() {
      return Math.min(this.offset + this.limit, this.filteredPatients.length) || 1;
    },
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.slicePatients();
    }
  },

  methods: {
    organizationChanged() {
      this.currentShopId = null
      const filtered = this.filterShopIdOptions.filter(i => i.orgId === this.currentOrganization)
      if (filtered.length === 1) {
        this.currentShopId = filtered[0].shopId
      }
    },
    async createFakeExam(item) {
      try {
        this.creatingFakeExam = true;
        const url = `${this.API_SERVICE}/siview/patients/fake-exam`
        const config = { headers: { "Content-Type": "application/json" } }
        const data = { id: item.id };
        await axios.post(url, data, config);
        this.handleRefresh();
      } catch (e) {
        console.log(e);
      } finally {
        this.creatingFakeExam = false;
      }

    },
    async fetchPatients() {
      if (!this.filterShopIdOptions.length) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true
      const url = this.API_SERVICE + '/siview/' + sessionStorage.getItem('userOrgID') + '/patients';
      const config = { headers: { "Content-Type": "application/json" } }
      const data = { params: { shopIds: Array.from(new Set(this.filterShopIdOptions.map(i => i.shopId))).join(',') } }

      window.axios
        .get(url, data, config)
        .then(r => r.data)
        .then(patients => {
          this.allPatients = patients;
          this.handleSearch();
        })
        .catch(function (error) {
          console.error(error)
        }).finally(() => {
          this.isLoading = false
        });
    },
    async fetchShops() {
      try {
        this.isLoading = true;
        const url = this.API_SERVICE + '/siview/user/' + sessionStorage.getItem('userID') + '/shops';
        const config = { headers: { "Content-Type": "application/json" } }
        const data = null
        const shops = await window.axios.get(url, data, config).then(r => r.data)
        this.filterShopIdOptions = shops
        const shopToSelect = shops.find(i => i.orgId === this.currentOrganization)
        if (shopToSelect) {
          this.currentShopId = shopToSelect.shopId
        }
        return shops;
      } catch (e) {
        console.log(e)
      }
    },
    async openConsultation(patient) {
      if (!patient.last_consult) return;
      try {
        this.isConsultationLoading = true
        this.modalData.patient = patient;
        const url = this.API_SERVICE + '/siview/' + sessionStorage.getItem('userOrgID') + '/patients/' + patient.id + '/consultations';
        const config = { headers: { "Content-Type": "application/json" } }
        const data = null
        const consultations = await window.axios.get(url, data, config).then(r => r.data)
        // using select's value to get the default cylinder, we may change that to use the file_number (packageID) to get the package's organization if needed
        const defaultCylinder = await window.axios.get(this.API_SERVICE +  '/siview/' + this.currentOrganization + "/cylinder", config).then(r => r.data)
        if (defaultCylinder && defaultCylinder.length) {
          this.modalData.defaultCylinder = defaultCylinder[0].defaultOption;
        } 
        this.modalData.mConsults = [consultations[0]];
        document.getElementsByClassName('wrapper')[0].style = 'overflow: hidden'
        this.showConsults = true;
      } catch (e) {
        console.log(e);
      } finally {
        this.isConsultationLoading = false
      }
    },
    handleConsultClose() {
      this.showConsults = false
      document.getElementsByClassName('wrapper')[0].style = ''
    },
    slicePatients() {
      this.tableData = JSON.parse(JSON.stringify(this.filteredPatients)).slice(this.offset, this.offset + this.limit)
    },
    handleRefresh() {
      this.fetchPatients();
    },
    async handleForceRefresh() {
      try {
        this.isLoading = true
        let allData = [];
        for (const shopId of this.filterShopIdOptions) {
          const url = this.API_SERVICE + '/siview/' + sessionStorage.getItem('userOrgID') + '/shops/' + shopId + '/patients/refresh';
          const config = { headers: { "Content-Type": "application/json" } }
          const data = null
          const patients = await window.axios.post(url, data, config).then(r => r.data);
          allData = allData.concat(patients);
        }
        this.allPatients = allData;
        this.handleSearch();
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    updateLimit(newLimit) {
      this.offset = 0;
      this.slicePatients();
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.slicePatients();
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.slicePatients();
      }
    },
    formattedDate(date) {
      return new moment(date).format("MM/DD/YYYY")
    },
    handleSearch() {
      const searchFilter = this.currentSearchTxt;
      const dateFilter = this.currentFilterDate;
      const consultationFilter = this.consultationsOnly;
      const shopIdFilter = this.currentShopId;
      localStorage.setItem("currentOrgSelectedForFilters", this.currentOrganization)
      let response = JSON.parse(JSON.stringify(this.allPatients));
      if (shopIdFilter) {
        response = response.filter(i => String(i.shop_id) === String(shopIdFilter));
      }
      if (searchFilter) {
        response = response.filter(i => {
          const searchText = ((i.firstname || '') + ' ' + (i.lastname || '') + (i.web_emr_id || '') + (i.client_number || '')).toLowerCase();
          return searchText.includes(searchFilter.toLowerCase());
        });
      }
      if (dateFilter != 'all') {
        const filters = {
          'pastDay': moment(new Date()).subtract(1, 'day').toDate().toISOString(),
          'pastWeek': moment(new Date()).subtract(7, 'days').toDate().toISOString(),
          'pastMonth': moment(new Date()).subtract(1, 'month').toDate().toISOString(),
          'past3Months': moment(new Date()).subtract(3, 'months').toDate().toISOString(),
          'past6Months': moment(new Date()).subtract(6, 'months').toDate().toISOString(),
          'pastYear': moment(new Date()).subtract(1, 'year').toDate().toISOString(),
        };
        response = response.filter(i => i.updated_at >= filters[dateFilter]);
      }
      if (consultationFilter) {
        response = response.filter(i => i.last_consult);
      }
      this.filteredPatients = response;
      this.totalPatients = response.length;
      this.offset = 0;
      this.slicePatients();
    },
  },
  mounted() {
    this.fetchShops().then((shops) => {
      if (shops.length) {
        this.currentOrganization = shops[0].orgId
      }
      this.fetchPatients();
    });
  },

}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  // background-color: #84dace !important;
  color: white;

  .emr-id-cell {
    color: #fff !important
  }
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;
}

// .md-icon {
//   margin-left: 24px !important;
// }

#headers {
  transition: none;
  background-color: #edf2f7 !important;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}

.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
